import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  LoadingIndicatorComponent,
  Sizes,
} from '../loading-indicator/loading-indicator.component';

@Component({
  selector: 'app-loading-message-modal',
  template: `
    <div data-test-selector="loading-message-modal">
      <div class="modal-header flex-row justify-content-between"></div>
      <div class="modal-body">
        <app-loading-indicator [message]="message"></app-loading-indicator>
      </div>
    </div>
  `,
  styles: [
    `
      .modal-body {
        padding: 2rem;
        text-align: center;
      }
      .modal-body {
        font-size: 1rem;
      }
    `,
  ],
  standalone: false,
})
export class LoadingMessageModalComponent {
  @Input({ required: true }) message: string = '';
  sizes = Sizes;

  constructor(public activeModal: NgbActiveModal) {}
}
